module.exports = __webpack_public_path__ + "static/media/next-activity-logo.a0c36eda.svg";